import React from 'react'
import { connect } from 'react-redux'
import HeaderTitle from '../Header/HeaderTitle'
import {
  getWebhookList,
  getActiveSheets,
  getSheetColumns,
  getWorkspaces,
  createWebhook,
  updateWebhook,
  deleteWebhook,
  checkSheetColumns,
  resetForm,
  resetSuccessMessage,
} from '../../store/WebhooksManagement/actionCreator'
import CreateWebhookDialog from './CreateWebhookDialog'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  Tooltip,
} from '@mui/material'
import WebhookHelpDialog from './WebhookHelpDialog'
import apiConfig from '../../config/apiConfig'
import MrtReusableTable from '../Utils/MrtReusableTable'
import { ziptieColors } from '../../config/themeConfig'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../Utils/FireFlyVnextHelpers'

export class WebhooksManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      webhooksList: [],
      activeSheets: [],
      sheetColumns: [],
      workspaces: [],
      loading: false,
      createDialogOpen: false,
      webhookHelpOpen: false,
      createHelpOpen: false,
      webhookSuccessOpen: false,
      webhookSuccessMessage: '',
      showDeleteDialog: false,
      pendingDeleteRow: null,
    }
    this.baseState = { ...this.state }
    this.handleCreateOpen = this.handleCreateOpen.bind(this)
    this.handleCreateClose = this.handleCreateClose.bind(this)
    this.createNewWebhook = this.createNewWebhook.bind(this)
    this.formatStatus = this.formatStatus.bind(this)
    this.dialogBox = React.createRef()
    this.handleWebhookHelpOpen = this.handleWebhookHelpOpen.bind(this)
    this.handleWebhookHelpClose = this.handleWebhookHelpClose.bind(this)
    this.handleCreateHelpOpen = this.handleCreateHelpOpen.bind(this)
    this.handleCreateHelpClose = this.handleCreateHelpClose.bind(this)
    this.handleSuccessOpen = this.handleSuccessOpen.bind(this)
    this.handleSuccessClose = this.handleSuccessClose.bind(this)
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
      lanId: undefined,
    },
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Webhook Management',
        'Webhook Management Page Load',
        userInfo,
      )
    }
    this.setState({ loading: true })
    await this.props.getWebhookList()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      webhooksList: JSON.parse(JSON.stringify(nextProps.webhooksList)),
      webhookSuccessMessage: nextProps.webhookSuccessMessage,
      loading: false,
    })
  }

  async handleCreateOpen() {
    await this.props.getWorkspaces()
    this.setState({ createDialogOpen: true })
  }

  handleCreateClose() {
    this.setState({ createDialogOpen: false })
    this.props.resetForm()
    this.dialogBox.current.resetForm()
  }

  handleWebhookHelpOpen() {
    this.setState({ webhookHelpOpen: true })
  }

  handleWebhookHelpClose() {
    this.setState({ webhookHelpOpen: false })
  }

  handleCreateHelpOpen() {
    this.setState({ createHelpOpen: true })
  }

  handleCreateHelpClose() {
    this.setState({ createHelpOpen: false })
  }

  handleSuccessOpen() {
    this.setState({ webhookSuccessOpen: true })
  }

  async handleSuccessClose() {
    await this.setState({
      webhookSuccessOpen: false,
      createDialogOpen: false,
    })
    this.props.resetSuccessMessage()
  }

  toggleWebhook = (event, id, callbackUrl, name) => {
    let newWebhookData
    if (event.target.value === 'true') {
      newWebhookData = {
        callbackUrl: callbackUrl,
        name: name,
        enabled: false,
      }
    } else {
      newWebhookData = {
        callbackUrl: callbackUrl,
        name: name,
        enabled: true,
      }
    }
    handleFireflySendClickEvent(
      'CLICK',
      'Webhook Management',
      'Webhook Management - Toggle Webhook',
      this.props.userInfo,
    )
    this.props.updateWebhook(id, newWebhookData)
  }

  createNewWebhook = (event, id, callbackUrl, name, user, columns) => {
    handleFireflySendClickEvent(
      'CLICK',
      'Webhook Management',
      'Webhook Management - Create Webhook',
      user,
    )
    event.preventDefault()
    const userName = user.email
      .substring(0, user.email.indexOf('@'))
      .replace('.', ' ')
    const ownerWithoutSpaces = userName.replace(' ', '>')
    let columnIds = []
    if (columns.length > 0) {
      columnIds = columns.map((column) => {
        return column.value
      })
    }
    const newWebhookData = {
      callbackUrl: `${apiConfig.api.rapidUrl}/${callbackUrl}`,
      name: name + '|' + ownerWithoutSpaces,
      smartsheetId: id,
      owner: userName,
      columnIds: columnIds,
    }
    this.setState({ webhookSuccessOpen: true })
    this.props.checkSheetColumns(newWebhookData)
    this.dialogBox.current.resetForm()
  }

  formatStatus = (input) => {
    let formattedStatus
    if (input === 'ENABLED') {
      formattedStatus = 'Enabled'
    } else if (input === 'NEW_NOT_VERIFIED') {
      formattedStatus = 'Not Verified'
    } else if (input === 'DISABLED_BY_OWNER') {
      formattedStatus = 'Disabled By Owner'
    } else if (input === 'DISABLED_VERIFICATION_FAILED') {
      formattedStatus = 'Verification Failed'
    } else if (input === 'DISABLED_SCOPE_INACCESSIBLE') {
      formattedStatus = 'Smartsheet Scope Not Accessible'
    } else {
      formattedStatus = 'Disabled by Smartsheet'
    }
    return formattedStatus
  }

  deleteWebhook = (row) => () => {
    handleFireflySendClickEvent(
      'CLICK',
      'Webhook Management',
      'Webhook Management - Delete Webhook',
      this.props.userInfo,
    )
    if (row && row.original && row.original.id) {
      this.props.deleteWebhook(row.original.id)
    }
  }

  openDeleteDialog = (row) => () => {
    this.setState({ showDeleteDialog: true, pendingDeleteRow: row })
  }

  closeDeleteDialog = () => {
    this.setState({ showDeleteDialog: false, pendingDeleteRow: null })
  }

  confirmDelete = () => {
    const { pendingDeleteRow } = this.state
    if (
      pendingDeleteRow &&
      pendingDeleteRow.original &&
      pendingDeleteRow.original.id
    ) {
      this.props.deleteWebhook(pendingDeleteRow.original.id)
    }
    this.closeDeleteDialog()
  }

  render() {
    let currentWebhooks = []
    if (this.state.webhooksList[0] !== 'Error Loading Webhooks..') {
      const webhooksColumns = [
        {
          accessorFn: (row) => row.name,
          header: 'Name',
          id: 'name',
          size: 400,
          Cell: ({ cell, row }) => {
            let formattedWebhookName
            const value = cell.getValue()
            if (value && value.includes('|')) {
              formattedWebhookName = value.substring(0, value.lastIndexOf('|'))
            } else if (value && value.includes('<')) {
              formattedWebhookName = value.substring(0, value.lastIndexOf('<'))
            } else {
              formattedWebhookName = value
            }
            return (
              <a
                href={row.original.sheetUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {formattedWebhookName}
              </a>
            )
          },
        },
        {
          accessorKey: 'smartsheetId',
          header: 'Smartsheet Id',
          enableHiding: true,
        },
        {
          accessorFn: (row) => row.name,
          header: 'Owner',
          id: 'owner',
          Cell: ({ cell }) => {
            let formattedOwnerName
            const value = cell.getValue()
            if (value && value.includes('|')) {
              const unformattedOwnerName = value.substring(
                value.lastIndexOf('|') + 1,
              )
              formattedOwnerName = unformattedOwnerName.replace('>', ' ')
            } else if (value && value.includes('<')) {
              const unformattedOwnerName = value.substring(
                value.lastIndexOf('<') + 1,
              )
              formattedOwnerName = unformattedOwnerName.replace('>', ' ')
            } else {
              formattedOwnerName = ''
            }
            return formattedOwnerName
          },
        },
        {
          accessorKey: 'lastSuccessfulCallback',
          header: 'Last Successful Validation',
          size: 200,
          Cell: ({ cell }) => {
            const value = cell.getValue()
            let displayedDateTime
            if (!value) {
              displayedDateTime = 'N/A'
            } else {
              const formattedDate = new Date(value).toLocaleDateString()
              const unformattedDate = new Date(value)
              const hours = unformattedDate.getHours()
              const minutes = unformattedDate.getMinutes()
              let displayHours
              let amPm
              if (hours > 12) {
                displayHours = hours - 12
                amPm = 'PM'
              } else if (hours === 0) {
                displayHours = 12
                amPm = 'AM'
              } else {
                displayHours = hours
                amPm = 'AM'
              }
              const displayMinutes = (minutes < 10 ? '0' : '') + minutes
              displayedDateTime =
                formattedDate +
                ' - ' +
                displayHours +
                ':' +
                displayMinutes +
                ' ' +
                amPm
            }
            return displayedDateTime
          },
        },
        {
          accessorKey: 'webhookType',
          header: 'Webhook Type',
          Cell: ({ cell, row }) => {
            const value = row.original.callbackUrl
            if (!value) return ''
            const rawType = value.split('/v1/callback_')[1]
            if (!rawType) return ''
            const formattedType = rawType
              .split('_')
              .map(
                (word) => word[0].toUpperCase() + word.slice(1).toLowerCase(),
              )
              .join(' ')
            return formattedType
          },
        },
        {
          accessorKey: 'callbackUrl',
          header: 'Callback Url',
          enableHiding: true,
        },
        {
          accessorKey: 'enabled',
          header: 'Disable/Enable',
          Cell: ({ cell, row }) => (
            <FormGroup>
              <FormControlLabel
                control={
                  <Tooltip title={this.formatStatus(row.original.status)}>
                    <Switch
                      color="success"
                      checked={cell.getValue()}
                      value={cell.getValue()}
                      onChange={(event) =>
                        this.toggleWebhook(
                          event,
                          row.original.id,
                          row.original.callbackUrl,
                          row.original.name,
                        )
                      }
                    />
                  </Tooltip>
                }
              />
            </FormGroup>
          ),
        },
        {
          accessorKey: 'id',
          header: 'Webhook Id',
          enableHiding: true,
        },
        {
          accessorKey: 'sheetUrl',
          header: 'Smartsheet Url',
          enableHiding: true,
        },
        {
          accessorKey: 'sheetName',
          header: 'Smartsheet Name',
          enableHiding: true,
        },
        {
          accessorKey: 'status',
          header: 'Status',
          enableHiding: true,
          Cell: ({ cell }) => this.formatStatus(cell.getValue()),
        },
      ]

      const defaultColumns = [
        'name',
        'lastSuccessfulCallback',
        'webhookType',
        'enabled',
      ]

      currentWebhooks = (
        <MrtReusableTable
          pageTitle="Webhooks"
          columns={webhooksColumns}
          defaultColumns={defaultColumns}
          rowData={this.props.webhooksList}
          loading={this.state.loading}
          loadingMessage="Loading Webhooks..."
          pageSize={[10, 20, 50]}
          enableRowActions={true}
          menuButtons={
            <div>
              <Tooltip title="Help">
                <IconButton
                  onClick={this.handleWebhookHelpOpen}
                  sx={{
                    color: ziptieColors.primary.contrastText,
                    marginLeft: '-4px',
                  }}
                >
                  <HelpOutlineIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Create New Webhook">
                <IconButton
                  onClick={this.handleCreateOpen}
                  sx={{
                    color: ziptieColors.primary.contrastText,
                    marginLeft: '-4px',
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </div>
          }
          rowActions={({ row }) => (
            <Tooltip title="Delete Webhook">
              <IconButton color="error" onClick={this.openDeleteDialog(row)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
        />
      )
    } else {
      currentWebhooks = this.state.webhooksList
    }

    const webhooksPanel = <div>{currentWebhooks}</div>

    return (
      <div>
        <HeaderTitle title="Webhooks Management" />
        <Grid container spacing={16}>
          <Grid item size={{ xs: 12 }}>
            <Dialog
              open={this.state.showDeleteDialog}
              onClose={this.closeDeleteDialog}
            >
              <DialogTitle>Confirm Deletion</DialogTitle>
              <DialogContent>
                Are you sure you want to remove this webhook?
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeDeleteDialog} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={this.confirmDelete}
                  color="error"
                  variant="contained"
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
            <WebhookHelpDialog
              open={this.state.webhookHelpOpen}
              handleWebhookHelpClose={this.handleWebhookHelpClose}
            />
            <CreateWebhookDialog
              open={this.state.createDialogOpen}
              handleCreateClose={this.handleCreateClose}
              createNewWebhook={this.createNewWebhook}
              getActiveSheets={this.props.getActiveSheets}
              getSheetColumns={this.props.getSheetColumns}
              activeSheets={this.props.activeSheets}
              sheetColumns={this.props.sheetColumns}
              workspaces={this.props.workspaces}
              user={this.props.userInfo}
              ref={this.dialogBox}
              helpOpen={this.state.createHelpOpen}
              successOpen={this.state.webhookSuccessOpen}
              successMessage={this.state.webhookSuccessMessage}
              handleCreateHelpOpen={this.handleCreateHelpOpen}
              handleCreateHelpClose={this.handleCreateHelpClose}
              handleSuccessOpen={this.handleSuccessOpen}
              handleSuccessClose={this.handleSuccessClose}
            />
            {webhooksPanel}
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    webhooksList: state.webhookManagement.webhooksList,
    activeSheets: state.webhookManagement.activeSheets,
    sheetColumns: state.webhookManagement.sheetColumns,
    workspaces: state.webhookManagement.workspaces,
    webhookSuccessMessage: state.webhookManagement.webhookSuccessMessage,
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {
  getWebhookList,
  getWorkspaces,
  createWebhook,
  updateWebhook,
  deleteWebhook,
  getActiveSheets,
  getSheetColumns,
  checkSheetColumns,
  resetForm,
  resetSuccessMessage,
}

export default connect(mapStateToProps, mapDispatchToProps)(WebhooksManagement)
